import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-banker-group-modal-topup',
  templateUrl: './banker-group-modal-topup.component.html',
  styleUrls: ['./banker-group-modal-topup.component.scss']
})
export class BankerGroupModalTopupComponent {

  public data: any = {};
  @Input() banker_group_uuid: string;
  @Output() closeEvent = new EventEmitter<boolean>();
  public banks: any = [];
  
  constructor(private http: HttpService) { 
    this.init();
  }

  async init() {
    let rtn:any = await this.http.post("/admin/adjustment-init")
    this.banks = rtn.banks;
  }
  async submit() {
    this.data.banker_group_uuid = this.banker_group_uuid;

    let rtn:any = await this.http.post("/admin/banker-group/topup", this.data);

    if(rtn.status) {
      this.closeEvent.emit(true);
    }
  }

}
